module.exports = __webpack_public_path__ + "img/generated-1772420733746.dc5480dd.png";